/* TaxMapper — standalone page wrapping the TaxMapperTab.
 *
 * Map chart-of-accounts → tax-form lines. Belongs in Accounting (it's
 * Chart of Accounts configuration, not advisory work).
 */
import { useWorkspace } from '../context/WorkspaceContext';
import { TaxMapperTab } from '../components/cfobuck/TaxMapperTab';
import { Map, FileBarChart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';

export default function TaxMapper() {
  const { currentWorkspace } = useWorkspace();
  const wsId = currentWorkspace?.workspace_id;
  const navigate = useNavigate();

  return (
    <div className="space-y-6" data-testid="tax-mapper-page">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-600 flex items-center justify-center shadow-lg shadow-emerald-500/20">
            <Map className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="text-3xl font-bold tracking-tight text-foreground" style={{ fontFamily: "'Outfit', sans-serif" }} data-testid="tax-mapper-heading">
              Tax Mapper
            </h1>
            <p className="text-sm text-muted-foreground">
              Map your chart of accounts to specific tax form lines for streamlined tax prep
            </p>
          </div>
        </div>
        <Button
          onClick={() => navigate('/reports?report=tax-mapping')}
          variant="outline"
          className="gap-2"
          data-testid="tax-mapper-view-report-btn"
        >
          <FileBarChart className="w-4 h-4" />
          View Tax Mapping Report
        </Button>
      </div>

      <TaxMapperTab workspaceId={wsId} />
    </div>
  );
}
